"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.hasCategories = hasCategories;
exports.isGroup = isGroup;
exports.normalizeForDropdown = normalizeForDropdown;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _DropdownSelectizeGroup = require("@insided/shared/uikit/dropdown/DropdownSelectizeGroup");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function hasCategories(c) {
  return 'categories' in c && !!c.categories && !!c.categories.length;
}

function isGroup(c) {
  return c.type === 4 || c.type === 5 || c.type === 6;
}

function normalizeForDropdown(categories) {
  var groupCategory = {
    groupId: 0,
    groupName: 'Groups',
    type: 1,
    categories: []
  };
  return categories.reduce(function (acc, parentOrGroup) {
    if (isGroup(parentOrGroup)) {
      groupCategory.categories.push({
        categoryId: parentOrGroup.groupId,
        categoryName: parentOrGroup.groupName
      });
      return acc;
    }

    return acc.concat([parentOrGroup]);
  }, []).concat([groupCategory]).filter(hasCategories);
}

var CategorySelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategorySelector, _Component);

  var _super = _createSuper(CategorySelector);

  function CategorySelector() {
    (0, _classCallCheck2.default)(this, CategorySelector);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CategorySelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          categories = _this$props.categories,
          selectedCategoryId = _this$props.selectedCategoryId,
          placeholder = _this$props.placeholder;
      return (0, _preact.h)(_DropdownSelectizeGroup.DropdownSelectizeGroup, {
        className: "qa-category-select",
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Select category ...',
        selectedValue: selectedCategoryId,
        onUpdate: this.props.onUpdate,
        newStyle: this.props.newStyle,
        optgroup: normalizeForDropdown(categories).map(function (parentCategory) {
          return {
            label: parentCategory.groupName,
            items: parentCategory.categories.map(function (item) {
              return {
                value: item.categoryId,
                label: item.categoryName
              };
            })
          };
        })
      });
    }
  }]);
  return CategorySelector;
}(_preact.Component);

exports.default = CategorySelector;